<app-tiny-alert *ngIf="!readOnly" [isProcessed]="'edited'" message="exception-mode.alert-penalties">
  <span (click)="open = true" button>
    {{ 'exception-mode.alert-button-edit' | translate }}
  </span></app-tiny-alert
><app-tiny-alert *ngIf="readOnly" [isProcessed]="'view'" message="exception-mode.alert-penalties">
  <span (click)="open = true" button>
    {{ 'exception-mode.alert-button-view' | translate }}
  </span></app-tiny-alert
><app-modal
  [isActive]="open"
  (modalState)="open = false"
  [showCloseFooter]="false"
  [enableFooter]="true"
  [isLarge]="true"
  [zIndex]="42"
>
  <p *ngIf="!readOnly" class="modal-card-title" modal-title>
    {{ 'exception-mode.alert-penalties-edit' | translate }}
  </p>

  <p *ngIf="readOnly && !(isAirline$ | async)" class="modal-card-title" modal-title>
    {{ 'exception-mode.modal-title-penalties-view' | translate }}
  </p>

  <p *ngIf="readOnly && (isAirline$ | async)" class="modal-card-title" modal-title>
    {{ 'exception-mode.modal-title-fare-rules' | translate }}
  </p>

  <span modal-content *ngIf="(isAirline$ | async) && !readOnly">
    {{ 'exception-mode.modal-title-penalties-view' | translate }}
  </span>

  <div class="columns" modal-content *ngIf="(isAirline$ | async) && !readOnly">
    <div class="column" *ngFor="let penalty of newPenalties; let i = index">
      <app-input-select-addon
        type="number"
        [isGroup]="false"
        id="penalty{{ i }}"
        label="{{ 'shared.' + penalty.passengerType | translate }}"
        [passengerType]="penalty.passengerType"
        [allowMl]="(machineLearningModel$ | async).machineLearningEnabled"
        [farebasisMl]="fareBasisMachineLearning$ | async"
        [currencies]="currencies"
        [valueSelect]="penalty?.currency"
        [valueInput]="penalty.value"
        (changeValue)="penalty.value = $event * 1; validatePenalties()"
        (changeSelect)="penalty.currency = $event; validatePenalties()"
        [error]="false"
        [disabled]="false"
        (onChangeDynamicClases)="validateDynamicClasses($event)"
        (onChangeDisabledStatus)="disabled = $event"
      ></app-input-select-addon>
    </div>
  </div>

  <span modal-content *ngIf="(isAirline$ | async) && !readOnly">
    {{ 'exception-mode.modal-subtitle-additional-values' | translate }}
  </span>

  <div modal-content *ngIf="(isAirline$ | async) && !readOnly" class="columns">
    <div class="column">
      <app-input-select-addon
        type="number"
        [isGroup]="false"
        id="2"
        label="{{ 'exception-mode.modal-field-fee-tax' | translate }}"
        [currencies]="currencies"
        [valueSelect]="currentCurrency"
        [valueInput]="newFeeTax?.amount"
        (changeValue)="feeTaxOverride.amount = $event * 1"
        (changeSelect)="feeTaxOverride.currency = $event"
        [error]="false"
        [disabled]="false"
        (onChangeDynamicClases)="validateDynamicClasses($event)"
        (onChangeDisabledStatus)="disabled = $event"
      ></app-input-select-addon>
    </div>

    <div class="column">
      <app-input-select-addon
        type="number"
        [isGroup]="false"
        id="3"
        label="{{ 'exception-mode.modal-field-service-fee' | translate }}"
        [currencies]="currencies"
        [valueSelect]="currentCurrency"
        [valueInput]="newServiceFee?.amount"
        (changeValue)="serviceFeeOverride.amount = $event * 1"
        (changeSelect)="serviceFeeOverride.currency = $event"
        [error]="false"
        [disabled]="false"
        (onChangeDynamicClases)="validateDynamicClasses($event)"
        (onChangeDisabledStatus)="disabled = $event"
      ></app-input-select-addon>
    </div>
  </div>

  <div class="columns" modal-content *ngIf="showDetails">
    <div class="column">
      <app-tabs
        *ngIf="penaltiesByTypeUser?.length > 0"
        [tabs]="penaltiesByTypeUser"
        [sharedTranslate]="true"
        (activated)="changeContent($event)"
      >
        <p class="has-text-grey mb-2">
          {{ 'exception-mode.alert-farebasis-subtitle' | translate }}
        </p>
        <div [ngSwitch]="activeContent" tab-content>
          <ng-container
            *ngIf="{
              settings: machineLearningModel$ | async,
              hasError: MlhasError$ | async,
              machineLearningModel: fareBasisMachineLearning$ | async
            } as data"
          >
            <ng-container
              *ngIf="!data.settings?.machineLearningEnabled || data.hasError || readOnly"
            >
              <ng-container *ngFor="let penal of penaltiesByTypeUser; let i = index">
                <app-draggable-list
                  *ngIf="activeContent === i"
                  [managementtype]="'exangevoluntary'"
                  [list]="penal.listFareBasis"
                  [groupName]="i"
                  (changeFirst)="selectFarebasis($event)"
                  [type]="type"
                ></app-draggable-list>
              </ng-container>
            </ng-container>
            <app-draggable-list-ml
              *ngIf="data.settings?.machineLearningEnabled && !data.hasError && !readOnly"
              [managementtype]="'exangevoluntary'"
              [penaltyFareBasisMachineLearning]="data.machineLearningModel"
              (queryNotFound)="showError($event)"
              [type]="type"
              [passengerTypeFareBasis]="passengerTypeForClass"
            ></app-draggable-list-ml>
          </ng-container>
        </div>
      </app-tabs>
    </div>
  </div>

  <div
    class="container-footer"
    [class.without-feedback]="
      ((machineLearningModel$ | async) &&
        !(machineLearningModel$ | async).machineLearningEnabled) ||
      !showFeedback ||
      (MlhasError$ | async)
    "
    modal-footer
  >
    <div *ngIf="!(MlhasError$ | async) && showFeedback">
      <div
        class="ml-feedback"
        *ngIf="
          (machineLearningModel$ | async) && (machineLearningModel$ | async).machineLearningEnabled
        "
      >
        <div class="ml-feedback-actions">
          <div class="ml-feedback-info">
            <div><em class="mdi mdi-alert-circle mdi-18px" aria-hidden="true"></em> &nbsp;</div>
            <div>
              <p class="label-feedback">
                {{ 'cancellation-info.machine-learning.label-prediction' | translate }}
              </p>
              <p class="label-confiability">
                {{ 'cancellation-info.machine-learning.label-reliability' | translate }}
                {{ getReliabilityAverage(fareBasisMachineLearning$ | async) + '%' }}
              </p>
            </div>
          </div>
          <div class="feedback-buttons">
            <button
              type="button"
              class="button is-outlined is-link is-rounded mr-3"
              [class.active-feedback]="feedBackRating"
              (click)="sendFeedBack(true)"
            >
              <em class="mdi mdi-thumb-up-outline mdi-18px" aria-hidden="true"></em>
            </button>
            <button
              type="button"
              class="button is-outlined is-link is-rounded"
              [class.active-feedback]="feedBackRating === false"
              (click)="sendFeedBack(false)"
            >
              <em class="mdi mdi-thumb-down-outline mdi-18px" aria-hidden="true"></em>
            </button>
          </div>
        </div>
        <div class="textarea-review" *ngIf="needTextReview">
          <textarea
            name="review"
            id="review"
            cols="30"
            rows="5"
            [placeholder]="'cancellation-info.machine-learning.textarea-placeholder' | translate"
            [(ngModel)]="textFeedbackReview"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="save-section">
      <app-input-submit
        *ngIf="!readOnly"
        [inputText]="'shared.save' | translate"
        [type]="'submit'"
        [isLoading]="loading"
        [disabled]="
          (machineLearningModel$ | async)?.machineLearningEnabled &&
          showFeedback &&
          !(MlhasError$ | async)
            ? disabled || feedBackRating === undefined
            : disabled
        "
        (clickButton)="sendValues()"
      ></app-input-submit>
    </div></div
></app-modal>
